import React, { useMemo } from 'react';
import { twMerge } from 'utilities/src/twMerge';
import ga4 from 'tracking/src/ga4';
import MenuItem from '../../data/MenuItem';
import useFlyoutThemes from './themes';
import createTransitionEndHandler from '../../utils/transitions';

type FlyoutType = {
  subMenuItem: MenuItem;
};

function DropdownMenu({ subMenuItem }: FlyoutType) {
  const {
    flyoutSubUlContainer,
    flyoutSubUlClasses,
    flyoutSubLiClasses,
    flyoutSubLinkClasses,
    flyoutSubLinkThemeClasses,
    flyoutSubUlThemeClasses,
    flyoutSubLiThemeClasses,
  } = useFlyoutThemes({});

  const handleTransitionEnd = useMemo(
    () =>
      createTransitionEndHandler({
        onVisible: () =>
          ga4.assignEvent(process.env.NEXT_PUBLIC_GA4, 'old_topnav_viewed', {
            type: 'navbar_menu_event',
            url: document.URL,
          }),
      }),
    [],
  );

  return (
    <div
      className={twMerge(flyoutSubUlContainer, '[&.group-hover:visible]:[--is-visible:1]')}
      onTransitionEnd={handleTransitionEnd}
    >
      <ul className={twMerge('', flyoutSubUlClasses, flyoutSubUlThemeClasses)}>
        {subMenuItem.children.map((subitem: MenuItem) => (
          <li key={subitem.id} className={twMerge(flyoutSubLiClasses, flyoutSubLiThemeClasses)}>
            <a
              href={`${subitem.path}?nav=old`}
              className={twMerge(flyoutSubLinkClasses, flyoutSubLinkThemeClasses)}
            >
              {subitem.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropdownMenu;
